import { useParams } from 'react-router-dom';
import EditEventForm from './EditEventForm';
import { useGetEventsQuery } from './eventsApiSlice';
import { useGetUsersQuery } from '../users/usersApiSlice';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const EditEvent = () => {
    useTitle('Nirakar Satguru: Edit Event');

    const { id: eventId } = useParams(); // params.id को eventId के रूप में रीनेम करें ताकि भ्रम से बचा जा सके
    console.log('params eventId', eventId);

    const { isManager, isAdmin, id: currentUserId } = useAuth(); // useAuth से लॉगिन किए हुए यूजर की ID प्राप्त करें
    console.log('AuthHook currentUserId:', currentUserId, 'isManager:', isManager, 'isAdmin:', isAdmin); // इसे यहाँ भी लॉग करें

    const { pageNumber = 1 } = useSelector((state) => state?.event || {}); 

    const { event } = useGetEventsQuery({ page: pageNumber }, {
        selectFromResult: ({ data }) => ({
            event: data?.entities[eventId] // eventId का उपयोग करें
        }),
    });
    
    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids ? data.ids.map(userId => data.entities[userId]) : []
        }),
    });

    // लोडिंग स्टेट को अधिक स्पष्ट बनाएं
    if (!event || !users?.length) {
        return <div className="text-center"><Spinner animation="border" role="status" /></div>;
    }

    // एक्सेस कंट्रोल लॉजिक
    // यह अज्यूम किया गया है कि `event.createdBy` यूजर की `_id` स्ट्रिंग से मैच करता है
    // और `users` ऐरे में उस `id` वाला यूजर है।
    // const currentUser = users.find(user => user.id === event.createdBy); // इसकी यहाँ सीधी आवश्यकता नहीं है

    if (!isManager && !isAdmin) {
        // यदि यूजर न तो मैनेजर है न ही एडमिन, तो उसे केवल अपने इवेंट्स को एडिट करने की अनुमति दें
        // event.createdBy को लॉगिन किए हुए यूजर की ID (currentUserId) से कंपेयर करें
        if (event.createdBy !== currentUserId) { 
            return <p className="errmsg">इस इवेंट को एक्सेस करने की अनुमति नहीं है।</p>;
        }
    }

    const content = <EditEventForm event={event} users={users} />;

    return content;
};
export default EditEvent;